import React, { useState, createContext, useEffect } from "react";
import { message } from "antd";
import {
  getToken,
  setB2BTokens,
} from "../AuthService/userData";
import { logEvent } from "@firebase/analytics";
import { analytics } from "../Services/Firebase";
import { axiosWithToken } from "../AuthService/AxiosToken";

const AuthContext = createContext({
  isLoggedIn: false,
  Loading: false,
  onLogin: () => {},
  onLogout: () => {},
});

export const AuthContextProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [Loading, setLoading] = useState(false);

  // Check if user has a token set in localStorage to maintain login status
  useEffect(() => {
    if (getToken() instanceof Error) {
      return setIsLoggedIn(false);
    } else {
      return setIsLoggedIn(true);
    }
  }, []);

  const loginHandler = (e, email, password,firebaseToken, type) => {
    e.preventDefault();
    setLoading(true);
    axiosWithToken
      .post(`${process.env.REACT_APP_ROUTER_URL}/provider/tenant/login`, {
        email: email,
        password: password,
        firebaseToken: firebaseToken,
      })
      .then((response) => {
        setIsLoggedIn(true);
        setB2BTokens(response.data);
        setLoading(false);
        message.success(
          `Welcome Back ${
            response.data.providerUserInfo.firstName +
            ` ` +
            response.data.providerUserInfo.lastName
          }`
        );

        logEvent(analytics, "Provider_Success_login", {
          email: email,
        });
      })
      .catch((error) => {
        setLoading(false);
        {
          error.response &&
            message.error(
              `Sorry ${error.response.data.message ?? "unknown error"}`
            );
        }
        logEvent(analytics, "Provider_Failed_login", {
          email: email,
        });
      });
  };

  const logoutHandler = () => {
    setIsLoggedIn(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        Loading: Loading,
        onLogin: loginHandler,
        onLogout: logoutHandler,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
